/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: dG0K2EDAwBAk

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import Header from "../../Header"; // plasmic-import: 4ClPPEaVaNLI/component
import ServiceMessage from "../../ServiceMessage"; // plasmic-import: OnWTFNPo14Tf/component
import FeaturesTopSection from "../../FeaturesTopSection"; // plasmic-import: uw79hRWChb6G/component
import FeaturesNavigation from "../../FeaturesNavigation"; // plasmic-import: iNIVOnwl5FXM/component
import { DOMEventListener } from "@myevaluations/myevals-plasmic-utils/dist/code-components/DOMEventListener/DOMEventListener"; // plasmic-import: 0SjDtb1E99mA/codeComponent
import FeaturesMyEvaluations from "../../FeaturesMyEvaluations"; // plasmic-import: Dlxm4vvfq1tf/component
import FeaturesMyCme from "../../FeaturesMyCme"; // plasmic-import: n8fP5hwrb7Lg/component
import FeaturesMyGme from "../../FeaturesMyGme"; // plasmic-import: UZhBi-wdivTm/component
import CalloutSection from "../../CalloutSection"; // plasmic-import: hGcTP4LoXXzT/component
import Footer from "../../Footer"; // plasmic-import: AN9sHMOzPG9-/component
import ContactModal from "../../ContactModal"; // plasmic-import: 2lCEPY1ezZ3j/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic.module.css"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectcss
import sty from "./PlasmicFeatures.module.css"; // plasmic-import: dG0K2EDAwBAk/css

createPlasmicElementProxy;

export type PlasmicFeatures__VariantMembers = {};
export type PlasmicFeatures__VariantsArgs = {};
type VariantPropType = keyof PlasmicFeatures__VariantsArgs;
export const PlasmicFeatures__VariantProps = new Array<VariantPropType>();

export type PlasmicFeatures__ArgsType = {};
type ArgPropType = keyof PlasmicFeatures__ArgsType;
export const PlasmicFeatures__ArgProps = new Array<ArgPropType>();

export type PlasmicFeatures__OverridesType = {
  root?: Flex__<"div">;
  header?: Flex__<typeof Header>;
  serviceMessageWrapper?: Flex__<"div">;
  serviceMessage?: Flex__<typeof ServiceMessage>;
  featuresTopSection?: Flex__<typeof FeaturesTopSection>;
  featuresNavigation?: Flex__<typeof FeaturesNavigation>;
  domEventListener?: Flex__<typeof DOMEventListener>;
  featuresMyEvaluations?: Flex__<typeof FeaturesMyEvaluations>;
  featuresMyCme?: Flex__<typeof FeaturesMyCme>;
  featuresMyGme?: Flex__<typeof FeaturesMyGme>;
  calloutSection?: Flex__<typeof CalloutSection>;
  footer?: Flex__<typeof Footer>;
  contactModal?: Flex__<typeof ContactModal>;
};

export interface DefaultFeaturesProps {}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicFeatures__RenderFunc(props: {
  variants: PlasmicFeatures__VariantsArgs;
  args: PlasmicFeatures__ArgsType;
  overrides: PlasmicFeatures__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "contactModal.open",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      },
      {
        path: "featuresNavigation.currentSection",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => "MyEvaluations"
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <React.Fragment>
      <Head>
        <meta name="twitter:card" content="summary" />
        <title key="title">{PlasmicFeatures.pageMetadata.title}</title>
        <meta
          key="og:title"
          property="og:title"
          content={PlasmicFeatures.pageMetadata.title}
        />
        <meta
          key="twitter:title"
          name="twitter:title"
          content={PlasmicFeatures.pageMetadata.title}
        />
        <meta
          key="description"
          name="description"
          content={PlasmicFeatures.pageMetadata.description}
        />
        <meta
          key="og:description"
          property="og:description"
          content={PlasmicFeatures.pageMetadata.description}
        />
        <meta
          key="twitter:description"
          name="twitter:description"
          content={PlasmicFeatures.pageMetadata.description}
        />
      </Head>

      <style>{`
        body {
          margin: 0;
        }
      `}</style>

      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            styleTokensClassNames,
            sty.root
          )}
        >
          <Header
            data-plasmic-name={"header"}
            data-plasmic-override={overrides.header}
            className={classNames("__wab_instance", sty.header)}
            currentPage={(() => {
              try {
                return $ctx.pagePath;
              } catch (e) {
                if (
                  e instanceof TypeError ||
                  e?.plasmicType === "PlasmicUndefinedDataError"
                ) {
                  return undefined;
                }
                throw e;
              }
            })()}
            onContactClick={async () => {
              const $steps = {};

              $steps["updateContactModalOpen"] = true
                ? (() => {
                    const actionArgs = {
                      variable: {
                        objRoot: $state,
                        variablePath: ["contactModal", "open"]
                      },
                      operation: 0,
                      value: true
                    };
                    return (({ variable, value, startIndex, deleteCount }) => {
                      if (!variable) {
                        return;
                      }
                      const { objRoot, variablePath } = variable;

                      $stateSet(objRoot, variablePath, value);
                      return value;
                    })?.apply(null, [actionArgs]);
                  })()
                : undefined;
              if (
                $steps["updateContactModalOpen"] != null &&
                typeof $steps["updateContactModalOpen"] === "object" &&
                typeof $steps["updateContactModalOpen"].then === "function"
              ) {
                $steps["updateContactModalOpen"] =
                  await $steps["updateContactModalOpen"];
              }
            }}
          />

          <div
            data-plasmic-name={"serviceMessageWrapper"}
            data-plasmic-override={overrides.serviceMessageWrapper}
            className={classNames(projectcss.all, sty.serviceMessageWrapper)}
          >
            <ServiceMessage
              data-plasmic-name={"serviceMessage"}
              data-plasmic-override={overrides.serviceMessage}
              className={classNames("__wab_instance", sty.serviceMessage)}
            />
          </div>
          <FeaturesTopSection
            data-plasmic-name={"featuresTopSection"}
            data-plasmic-override={overrides.featuresTopSection}
            className={classNames("__wab_instance", sty.featuresTopSection)}
          />

          <FeaturesNavigation
            data-plasmic-name={"featuresNavigation"}
            data-plasmic-override={overrides.featuresNavigation}
            className={classNames("__wab_instance", sty.featuresNavigation)}
            currentSection={generateStateValueProp($state, [
              "featuresNavigation",
              "currentSection"
            ])}
            onCurrentSectionChange={async (...eventArgs: any) => {
              generateStateOnChangeProp($state, [
                "featuresNavigation",
                "currentSection"
              ]).apply(null, eventArgs);

              if (
                eventArgs.length > 1 &&
                eventArgs[1] &&
                eventArgs[1]._plasmic_state_init_
              ) {
                return;
              }
            }}
            onProductClick={async Id => {
              const $steps = {};

              $steps["runCode"] = true
                ? (() => {
                    const actionArgs = {
                      customFunction: async () => {
                        return (() => {
                          function scrollTo(element) {
                            element.scrollIntoView({ behavior: "smooth" });
                          }
                          return scrollTo(window.document.getElementById(Id));
                        })();
                      }
                    };
                    return (({ customFunction }) => {
                      return customFunction();
                    })?.apply(null, [actionArgs]);
                  })()
                : undefined;
              if (
                $steps["runCode"] != null &&
                typeof $steps["runCode"] === "object" &&
                typeof $steps["runCode"].then === "function"
              ) {
                $steps["runCode"] = await $steps["runCode"];
              }
            }}
          />

          <DOMEventListener
            data-plasmic-name={"domEventListener"}
            data-plasmic-override={overrides.domEventListener}
            eventType={"scroll"}
            onEvent={async event => {
              const $steps = {};

              $steps["runCode"] = true
                ? (() => {
                    const actionArgs = {
                      customFunction: async () => {
                        return (() => {
                          function getVisibleElementId(offset = -20) {
                            const relevantIds = [
                              "MyEvaluations",
                              "MyCME",
                              "MyGME"
                            ];

                            const elements = document.querySelectorAll("[id]");
                            for (let element of elements) {
                              const { top, bottom } =
                                element.getBoundingClientRect();
                              const vHeight =
                                window.innerHeight ||
                                document.documentElement.clientHeight;
                              if (
                                (top + offset > 0 || bottom + offset > 0) &&
                                top < vHeight &&
                                relevantIds.includes(element.id)
                              ) {
                                return element.id;
                              }
                            }
                          }
                          const visibleElementId = getVisibleElementId();
                          if (visibleElementId) {
                            return ($state.featuresNavigation.currentSection =
                              visibleElementId);
                          }
                        })();
                      }
                    };
                    return (({ customFunction }) => {
                      return customFunction();
                    })?.apply(null, [actionArgs]);
                  })()
                : undefined;
              if (
                $steps["runCode"] != null &&
                typeof $steps["runCode"] === "object" &&
                typeof $steps["runCode"].then === "function"
              ) {
                $steps["runCode"] = await $steps["runCode"];
              }
            }}
            passive={true}
          />

          <FeaturesMyEvaluations
            data-plasmic-name={"featuresMyEvaluations"}
            data-plasmic-override={overrides.featuresMyEvaluations}
            className={classNames("__wab_instance", sty.featuresMyEvaluations)}
          />

          <FeaturesMyCme
            data-plasmic-name={"featuresMyCme"}
            data-plasmic-override={overrides.featuresMyCme}
            className={classNames("__wab_instance", sty.featuresMyCme)}
          />

          <FeaturesMyGme
            data-plasmic-name={"featuresMyGme"}
            data-plasmic-override={overrides.featuresMyGme}
            className={classNames("__wab_instance", sty.featuresMyGme)}
          />

          <CalloutSection
            data-plasmic-name={"calloutSection"}
            data-plasmic-override={overrides.calloutSection}
            className={classNames("__wab_instance", sty.calloutSection)}
            onContactClick={async () => {
              const $steps = {};

              $steps["updateContactModalOpen"] = true
                ? (() => {
                    const actionArgs = {
                      variable: {
                        objRoot: $state,
                        variablePath: ["contactModal", "open"]
                      },
                      operation: 0,
                      value: true
                    };
                    return (({ variable, value, startIndex, deleteCount }) => {
                      if (!variable) {
                        return;
                      }
                      const { objRoot, variablePath } = variable;

                      $stateSet(objRoot, variablePath, value);
                      return value;
                    })?.apply(null, [actionArgs]);
                  })()
                : undefined;
              if (
                $steps["updateContactModalOpen"] != null &&
                typeof $steps["updateContactModalOpen"] === "object" &&
                typeof $steps["updateContactModalOpen"].then === "function"
              ) {
                $steps["updateContactModalOpen"] =
                  await $steps["updateContactModalOpen"];
              }
            }}
          />

          <Footer
            data-plasmic-name={"footer"}
            data-plasmic-override={overrides.footer}
            className={classNames("__wab_instance", sty.footer)}
            onContactClick={async () => {
              const $steps = {};

              $steps["updateContactModalOpen"] = true
                ? (() => {
                    const actionArgs = {
                      variable: {
                        objRoot: $state,
                        variablePath: ["contactModal", "open"]
                      },
                      operation: 0,
                      value: true
                    };
                    return (({ variable, value, startIndex, deleteCount }) => {
                      if (!variable) {
                        return;
                      }
                      const { objRoot, variablePath } = variable;

                      $stateSet(objRoot, variablePath, value);
                      return value;
                    })?.apply(null, [actionArgs]);
                  })()
                : undefined;
              if (
                $steps["updateContactModalOpen"] != null &&
                typeof $steps["updateContactModalOpen"] === "object" &&
                typeof $steps["updateContactModalOpen"].then === "function"
              ) {
                $steps["updateContactModalOpen"] =
                  await $steps["updateContactModalOpen"];
              }
            }}
          />

          <ContactModal
            data-plasmic-name={"contactModal"}
            data-plasmic-override={overrides.contactModal}
            className={classNames("__wab_instance", sty.contactModal)}
            onOpenChange={async (...eventArgs: any) => {
              generateStateOnChangeProp($state, ["contactModal", "open"]).apply(
                null,
                eventArgs
              );

              if (
                eventArgs.length > 1 &&
                eventArgs[1] &&
                eventArgs[1]._plasmic_state_init_
              ) {
                return;
              }
            }}
            open={generateStateValueProp($state, ["contactModal", "open"])}
          />
        </div>
      </div>
    </React.Fragment>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "header",
    "serviceMessageWrapper",
    "serviceMessage",
    "featuresTopSection",
    "featuresNavigation",
    "domEventListener",
    "featuresMyEvaluations",
    "featuresMyCme",
    "featuresMyGme",
    "calloutSection",
    "footer",
    "contactModal"
  ],
  header: ["header"],
  serviceMessageWrapper: ["serviceMessageWrapper", "serviceMessage"],
  serviceMessage: ["serviceMessage"],
  featuresTopSection: ["featuresTopSection"],
  featuresNavigation: ["featuresNavigation"],
  domEventListener: ["domEventListener"],
  featuresMyEvaluations: ["featuresMyEvaluations"],
  featuresMyCme: ["featuresMyCme"],
  featuresMyGme: ["featuresMyGme"],
  calloutSection: ["calloutSection"],
  footer: ["footer"],
  contactModal: ["contactModal"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  header: typeof Header;
  serviceMessageWrapper: "div";
  serviceMessage: typeof ServiceMessage;
  featuresTopSection: typeof FeaturesTopSection;
  featuresNavigation: typeof FeaturesNavigation;
  domEventListener: typeof DOMEventListener;
  featuresMyEvaluations: typeof FeaturesMyEvaluations;
  featuresMyCme: typeof FeaturesMyCme;
  featuresMyGme: typeof FeaturesMyGme;
  calloutSection: typeof CalloutSection;
  footer: typeof Footer;
  contactModal: typeof ContactModal;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicFeatures__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicFeatures__VariantsArgs;
    args?: PlasmicFeatures__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicFeatures__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicFeatures__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicFeatures__ArgProps,
          internalVariantPropNames: PlasmicFeatures__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicFeatures__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicFeatures";
  } else {
    func.displayName = `PlasmicFeatures.${nodeName}`;
  }
  return func;
}

export const PlasmicFeatures = Object.assign(
  // Top-level PlasmicFeatures renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    header: makeNodeComponent("header"),
    serviceMessageWrapper: makeNodeComponent("serviceMessageWrapper"),
    serviceMessage: makeNodeComponent("serviceMessage"),
    featuresTopSection: makeNodeComponent("featuresTopSection"),
    featuresNavigation: makeNodeComponent("featuresNavigation"),
    domEventListener: makeNodeComponent("domEventListener"),
    featuresMyEvaluations: makeNodeComponent("featuresMyEvaluations"),
    featuresMyCme: makeNodeComponent("featuresMyCme"),
    featuresMyGme: makeNodeComponent("featuresMyGme"),
    calloutSection: makeNodeComponent("calloutSection"),
    footer: makeNodeComponent("footer"),
    contactModal: makeNodeComponent("contactModal"),

    // Metadata about props expected for PlasmicFeatures
    internalVariantProps: PlasmicFeatures__VariantProps,
    internalArgProps: PlasmicFeatures__ArgProps,

    // Page metadata
    pageMetadata: {
      title:
        "Features | The Human Approach in Medical Education Management™ - MyEvaluations",
      description:
        "Explore top features for managing GME, PA, and Nursing education programs effectively.",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicFeatures;
/* prettier-ignore-end */
